import { Mediator, app, payload } from "modular-openscriptjs";
import { eParse, inform, processStart, processEnd } from "../helpers";
import { analyze } from "../analytics";
import { STRINGS, api } from "../declarations";
import { routes } from "../backendRoutes";

const $e = app("$e");

export class ErrandMediator extends Mediator {
	$$errand = {
		needs: {
			creation: (ed, event) => {
				let { message } = eParse(ed);
				const item = message.get("item", { original_product_id: 0 });
				const userId = message.get("userId");

				return app("router").to("errands.edit-workflow", {
					errandId: item.original_product_id,
					u: userId,
				});
			},

			request: (ed, event) => {
				this.placeErrandRequest(ed, event);
			},
		},
	};

	async placeErrandRequest(ed, event) {
		let data = eParse(ed);

		let { message } = data;
		let errand_id = message.get("errand_id", 0);
		let company_id = message.get("logistics_company_id", 0);
		let fleet_type = message.get("fleet_type", "bike");
		let payment_time = message.get("payment_time", "before_delivery");
		let notes = message.get("notes");

		if (!errand_id || !company_id) {
			inform(
				"The provided information is incomplete",
				STRINGS.ERROR,
				3000
			);
			return this.broadcast($e.errand.has.requestError, ed);
		}

		processStart({ title: "Placing request" });

		let res = await api.post(
			`${routes.errands}/${errand_id}/place-request`,
			{
				errand_id,
				company_id: company_id,
				fleet_type,
				payment_time,
				notes,
			}
		);

		if (!res) {
			inform(
				"An error occurred while placing your errand request",
				STRINGS.ERROR
			);
			processEnd();
			return this.broadcast($e.errand.has.requestError, ed);
		}

		let resData = res.data;

		data.message.orderId = res.data.orderId;

		this.broadcast($e.order.placed, payload(data.message, data.meta));
		this.broadcast(
			$e.errand.is.requested,
			payload(data.message, data.meta)
		);

		analyze("place_order", {
			amount: res.data.amount,
			currency: res.data.currency,
			items_count: 1,
			order_type: "errand",
		});

		if (resData.paymentTime == "before_delivery") {
			inform(
				"Your errand request was placed successfully. Redirecting to payment",
				STRINGS.SUCCESS
			);

			this.broadcast(
				$e.order.needs.payment,
				payload({
					orderId: resData.orderId,
					amount: resData.amount,
					currency: resData.currency,
				})
			);
		} else {
			inform(
				"Your errand request was placed successfully",
				STRINGS.SUCCESS
			);

			app("router").to("order.track", { orderId: resData.orderId });
		}

		processEnd();
	}
}
